import { render, staticRenderFns } from "./MasterDataList.vue?vue&type=template&id=74c87ec2&scoped=true&"
import script from "./MasterDataList.vue?vue&type=script&lang=js&"
export * from "./MasterDataList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c87ec2",
  null
  
)

export default component.exports